/* ========================================================================
    Module: Functions
 ========================================================================== */
import { esc_html } from "~modules/util";
import {
    RegularMemberSelectOptionOrganizationType,
    CorporateSupportingMemberSelectOptionOrganizationType,
} from "~types/organization-select-option";

/**
 * 正会員の組織・機関名のドロップダウンの選択項目を生成する
 *
 * @param {RegularMemberSelectOptionOrganizationType[]} data
 * @param {string | null} oldValue
 * @returns {string}
 */
const regularMemberOrganizationSelectOptions = (
    data: RegularMemberSelectOptionOrganizationType[],
    oldValue: string | null,
): string => {
    let options = "";

    data.forEach((item) => {
        options += `<optgroup label="【${esc_html(
            item.member_type_name,
        )}】" class="optP"></optgroup>`;

        item.area_members.forEach((area_member) => {
            options += `<optgroup label="———${esc_html(area_member.area_name)}———">`;

            area_member.members.forEach((member) => {
                const optionValue = `rm-${member.id}`;

                options += `<option value="${optionValue}" ${
                    oldValue === optionValue ? "selected" : ""
                }>${esc_html(member.organization_name)}</option>`;
            });

            options += "</optgroup>";
        });
    });

    return options;
};

/**
 * 法人賛助会員の組織・機関名のドロップダウンの選択項目を生成する
 *
 * @param {CorporateSupportingMemberSelectOptionOrganizationType[]} data
 * @param {string | null} oldValue
 * @returns {string}
 */
const corporateSupportingMemberOrganizationSelectOptions = (
    data: CorporateSupportingMemberSelectOptionOrganizationType[],
    oldValue: string | null,
): string => {
    let options = `<optgroup label="【法人賛助会員】" class="optP">`;

    data.forEach((member) => {
        const optionValue = `csm-${member.id}`;

        options += `<option value="csm-${member.id}" ${
            oldValue === optionValue ? "selected" : ""
        }>${esc_html(member.corporate_name)}</option>`;
    });

    options += "</optgroup>";

    return options;
};

export {
    regularMemberOrganizationSelectOptions,
    corporateSupportingMemberOrganizationSelectOptions,
};
